module.exports = __webpack_public_path__ + "img/double.38d2fec9.png";